import "./_review.scss";
import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "@src/App";
// utils
import { getDiffFromNow, getDiffToString } from "@src/utils/date";
import { isExternalUrl, removeZeroWithSpace, getImageUrlWithMaxWidth } from "@src/utils";
import { getPartnerDetailUrl } from "@src/utils/route";
// api
import {
  ICommunityCommentListItem,
  ICommunityListItem,
  IBlogListItem,
} from "@src/api/community/community";
// review
import { ReviewProviderData } from "./Provider";
import { useReviewActions } from "./useReviewActions";
import { TReviewType, TViewType } from "./Intreface";
// components
import Blank from "../../common/blank/Blank";
import LoadingSpinner from "@src/components/common/loading/LoadingSpinner";
import { Tag, Chip, Icon, ButtonBox, ButtonWrap, SkeletonBase } from "@shared/src";
// images
import IconLock from "@assets/images/common/community/icon-lock@3x.png";
import IconReviewNew from "@assets/images/common/community/icon-review-new@3x.png";
import anonymousImg from "@assets/images/common/community/anonymous@3x.png";

// 리뷰 헤더
export const ReviewItemHeader = (props: {
  list: ICommunityCommentListItem | ICommunityListItem | IBlogListItem;
  reviewType?: TReviewType;
}) => {
  const { list, reviewType } = props;

  // 블로그 리뷰 여부
  const isBlog = reviewType === "blog" && "originUrl" in list;

  // 댓글 여부
  const isComment = "depth" in list;

  return (
    <div
      className={`review-item-header 
      ${isComment ? "review-item-header-comment" : ""} 
      ${isBlog ? "review-item-header-blog" : ""}`}
    >
      {/* 유저 아이콘 */}
      <div
        className="user-icon"
        style={{
          backgroundImage: `url(${
            "anonymous" in list && list.anonymous === 1 ? anonymousImg : list.profileUrl
          })`,
        }}
      ></div>
      {/* 유저 정보 */}
      <div className="user-info-wrap">
        <div className="user-nick-box">
          <span className="user-nick">{list.nick}</span>
          {/* {list.isCertification > 0 && <span className="user-verified">인증 <i className="icon icon-verified" style={{marginTop: -1}}></i></span>	} */}
          {/* 240614 리뉴얼로 이 부분 주석 처리 (인증 받은 회원 노출 아이콘) */}
        </div>
        {!isBlog && (
          <span className="user-route small">
            {"anonymous" in list && list.anonymous === 1 ? (
              <>{"비공개 / 비공개"}</>
            ) : (
              <>
                {"weddingMonth" in list &&
                  list.weddingMonth &&
                  `${list.weddingMonth} ${list.partnerText ? `/ ${list.partnerText}` : ""}`}
              </>
            )}
          </span>
        )}
      </div>
      {/* 작성 시간 */}
      <time className="user-writing-time" dateTime={list.regTsp}>
        {getDiffToString(list.regTsp)}
        {getDiffFromNow(list.regTsp, "hours") < 23 && (
          <img src={IconReviewNew} alt="New" width={14} />
        )}
      </time>
    </div>
  );
};

// 리뷰 푸터
export const ReviewItemFooter = (props: {
  list: ICommunityCommentListItem | ICommunityListItem;
  reviewType?: TReviewType;
  viewType: TViewType;
}) => {
  const { list, reviewType, viewType } = props;

  // 블로그 리뷰 여부
  const isBlog = reviewType === "blog" && "originUrl" in list;

  // 코멘트 여부
  const isComment = "depth" in list;

  // 비공개 여부
  const isBlocked = "secretAllow" in list && list.secretAllow === 0;

  // hooks
  const { likeAction } = useReviewActions();
  const user = useContext(UserContext);

  // useContext
  const { setCommunityModalData, setReviewDataDetail, setSpecificComment } =
    useContext(ReviewProviderData).data;

  return isBlog ? null : (
    <div
      className={`review-item-footer 
      ${isComment ? "review-item-footer-comment" : ""} 
      ${isBlog ? "review-item-footer-blog" : ""}`}
      style={{ padding: `${isBlocked ? "0" : ""}` }}
    >
      {!isBlocked || !isComment ? (
        <>
          <ButtonWrap className="" noPaddingPosition="all">
            <ButtonBox>
              {/* 좋아요 아이콘 영역 */}
              <div
                className="review-like-cnt footer-action"
                data-uuid={list.uuid}
                onClick={(e) => {
                  e.stopPropagation();
                  likeAction(list.uuid, list.isLike ? 0 : 1, isComment ? "comment" : "community");
                }}
              >
                <Icon name={list.isLike ? "HeartFillR500" : "HeartOutlineG900"} size={18} />{" "}
                <span>{list.likeCnt}</span>
                {/* 240614 리뉴얼로 좋아요 단일로 변경 */}
              </div>
            </ButtonBox>
            <ButtonBox>
              {/* 댓글 아이콘 영역 */}
              <div
                className="review-comment-cnt  footer-action"
                onClick={(e) => {
                  e.stopPropagation();
                  if (isComment) {
                    setSpecificComment({
                      id: Date.now(),
                      writeType: "reply",
                      commentData: list,
                      target: (e.target as HTMLElement).closest(".review-item"),
                    });
                  } else {
                    if (viewType === "list-summary") {
                      setReviewDataDetail({
                        id: Date.now(),
                        reviewData: list,
                      });
                    }
                  }
                }}
              >
                <Icon name={"Comment"} size={18} />
                {!isComment ? <span>{list.replyCnt}</span> : <span>답글달기</span>}
              </div>
            </ButtonBox>
          </ButtonWrap>
          {/* 수정/삭제 버튼 영역 */}
          {isComment && list.customerUuid === user?.me?.uuid && (
            <ButtonWrap className="review-modify-btn-wrap" noPaddingPosition="all">
              <ButtonBox
                className="footer-action"
                type="icon"
                onClick={(e: React.MouseEvent) => {
                  setSpecificComment({
                    id: Date.now(),
                    writeType: "modify",
                    commentData: list,
                    target: (e.target as HTMLElement).closest(".review-item"),
                  });
                }}
                text="수정"
              />
              <ButtonBox
                className="footer-action"
                type="icon"
                onClick={(e: React.MouseEvent) => {
                  setSpecificComment({
                    id: Date.now(),
                    writeType: "delete",
                    commentData: list,
                    target: (e.target as HTMLElement).closest(".review-item"),
                  });
                }}
                text="삭제"
              />
            </ButtonWrap>
          )}
          {/* 신고/차단 버튼 영역 */}
          {(!isComment || list.customerUuid !== user?.me?.uuid) && (
            <ButtonBox
              className="footer-action review-more-btn"
              type="icon"
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                setCommunityModalData({
                  id: Date.now(),
                  category: isComment ? 3 : 2,
                  communityUuid: list.uuid,
                  customerUuid: list.customerUuid,
                  reviewUuid: isComment ? list.rootUuid : list.uuid,
                });
              }}
            >
              <Icon name="MoreHorizontal" size={18} />
            </ButtonBox>
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

// 리뷰 본문
export const ReviewItemBody = (props: {
  list: ICommunityCommentListItem | ICommunityListItem | IBlogListItem;
  viewType: TViewType;
  reviewType: TReviewType;
}) => {
  const { list, viewType, reviewType } = props;

  // 블로그 리뷰 여부
  const isBlog = reviewType === "blog" && "originUrl" in list;

  // 코멘트 여부
  const isComment = "depth" in list;

  // 비밀글 열람 차단 여부
  const isBlocked = "secretAllow" in list && list.secretAllow === 0;

  // useContext
  const { partner, setReviewImageData, setReviewDataDetail } = useContext(ReviewProviderData).data;

  // 이미지 로딩 에러 핸들러
  const imgErrorHandler = (e: React.ChangeEvent<HTMLImageElement>) => {
    // e.target.closest("li").remove();
    // const target = e.target as HTMLImageElement;
    // target.src = ImgNotFound;
    // console.log(`image error ${e.target.src}`);
  };

  // 리뷰 상세 페이지 데이터 저장
  const reviewDetailDataHandler = (
    e: React.TouchEvent | React.MouseEvent,
    list: ICommunityListItem | ICommunityCommentListItem | IBlogListItem,
  ) => {
    const target = e.target as HTMLElement;
    if (target.closest(".review-item-images")) {
      return;
    } else {
      setReviewDataDetail({
        id: Date.now(),
        reviewData: list as ICommunityListItem,
      });
    }
  };

  // 리뷰 이미지 데이터 저장
  const reviewImageDataHandler = (
    imgIdx: number,
    list: ICommunityListItem | ICommunityCommentListItem | IBlogListItem,
  ) => {
    if (isBlog) return;
    if ("uuid" in list) {
      setReviewImageData({
        id: Date.now(),
        idx: imgIdx,
        photoData: list.images,
        total: list.images.length,
        reviewUuid: "rootUuid" in list ? list.rootUuid : list.uuid,
      });
    }
  };

  // 업체페이지 이동
  // 서버에서 받아온 link가 아닌 직접 정의한 링크로 이동 (다른곳에서 link가 쓰인다고 들었음)
  const goToPartnerPage = async (partnerUuid: string, partnerType: number | null) => {
    window.location.href = await getPartnerDetailUrl(partnerUuid, { partnerType: partnerType });
  };

  // 파트너 정보(카드) 데이터 - 이미지, 타입, 이름, 링크
  // 카드에 정보 없을 경우 파트너 정보로 대체
  const isListCardData =
    "card" in list ? (Array.isArray(list.card) ? list.card[0] : list.card) : null;
  const partnerProfileImg = !isComment
    ? isListCardData
      ? isListCardData.coverUrl
      : partner?.coverUrl
        ? partner.coverUrl
        : partner?.logoUrl
    : null;
  const partnerTypeName = !isComment
    ? isListCardData
      ? isListCardData.title
      : partner?.partnerTypeName
        ? partner.partnerTypeName
        : ""
    : null;
  const partnerType = !isComment
    ? isListCardData
      ? isListCardData.partnerType
      : partner?.partnerType
        ? partner.partnerType
        : null
    : null;
  const partnerName = !isComment
    ? isListCardData
      ? isListCardData.content
      : partner?.bizName
        ? partner.bizName
        : ""
    : null;
  const partnerUuid = !isComment
    ? isListCardData
      ? isListCardData.partnerUuid
      : partner?.uuid
        ? partner.uuid
        : ""
    : "";
  const partnerLink = !isComment ? (isListCardData ? isListCardData.link : null) : null;

  return (
    <div
      className={`review-item-body ${isComment ? "review-item-body-comment" : ""} ${
        isBlog ? "review-item-body-blog" : ""
      }`}
      onClick={(e) => {
        if (isBlog && "originUrl" in list && list.originUrl) {
          window.location.href = isExternalUrl(list.originUrl);
        }
        if (!isBlog && !isComment && viewType === "list-summary") {
          reviewDetailDataHandler(e, list);
        }
      }}
    >
      {viewType === "list-detail" && !isComment && !isBlog && (
        <div
          className="partner-info-wrap"
          onClick={() => {
            if (!partnerLink) return;
            goToPartnerPage(partnerUuid, partnerType);
          }}
        >
          <div
            className="partner-thumbnail"
            style={{ display: `${!partnerProfileImg ? "none" : ""}` }}
          >
            <img
              src={getImageUrlWithMaxWidth(partnerProfileImg, 600)}
              alt={partner?.bizName}
              onError={imgErrorHandler}
              onLoad={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.opacity = "1";
              }}
            />
          </div>
          <div className="partner-detail">
            <div className="partner-type">{partnerTypeName}</div>
            <div className="partner-name">{partnerName}</div>
          </div>
        </div>
      )}

      {/* 멘토 댓글 */}
      {"mentorState" in list && list.mentorState === 1 && (
        <div className="review-comment-mentor">
          <p>👑 새댁멘토의 댓글입니다. 👑</p>
        </div>
      )}

      {/* 비밀글 */}
      {"secret" in list && list.secret === 1 && (
        <p className={`review-comment-secret`} style={{ paddingBottom: `10px` }}>
          <img src={IconLock} alt="비밀글" width={18} />
          비밀글입니다. 글쓴이와 댓글 쓴 이만 볼 수 있어요.
        </p>
      )}

      {isBlocked ? (
        <></>
      ) : (
        <>
          {/* 열람 가능 댓글 */}
          {isBlog ? ( // 블로그 리뷰
            <div className="review-item-box">
              <div className="review-item-title">
                <h3>{removeZeroWithSpace(list.title)}</h3>
              </div>
              <div className="review-item-contents">
                <p>{removeZeroWithSpace(list.content)}</p>
              </div>
            </div>
          ) : (
            // 커뮤니티 리뷰, 댓글
            <p>
              {viewType !== "list-summary" ? (
                // 댓글 상대 list.uppernick
                <>
                  {isComment && list.depth === 2 && (
                    <span className="uppernick">@{list.upperNick}</span>
                  )}
                  {list.content}
                </>
              ) : (
                <>
                  {list.content.substr(0, 100)}
                  {list.content.length > 100 && (
                    <>
                      ...<span className="moreview"> 더보기</span>
                    </>
                  )}
                </>
              )}
            </p>
          )}
          {/* 리뷰 포맷 항목 - 커뮤니티 리뷰에만 있음 댓긅X 블로그 리뷰X */}
          {!isComment &&
            !isBlog &&
            "reviews" in list &&
            Array.isArray(list.reviews) &&
            list.reviews.length > 0 && (
              <div className="reivew-item-contents-form">
                {list.reviews.map((review: any, RIdx) => (
                  <div key={`review-item-contents-form-${RIdx}`}>
                    <h3>
                      {review.kname} <span className="icon icon-recommend"></span>
                    </h3>
                    <p className={viewType === "list-summary" ? "ellipsis" : ""}>{review.v}</p>
                  </div>
                ))}
              </div>
            )}
          {/* 리뷰 이미지 */}
          {list.images && Array.isArray(list.images) && list.images.length > 0 && (
            <ul
              className={`review-item-images-wrap ${
                "depth" in list ? "review-item-images-wrap-comment" : ""
              }`}
              style={{
                marginRight: isComment || list.images.length <= 2 ? "" : "-20px",
              }}
            >
              {list.images.map((image: { url: string }, imgIdx) => (
                <li
                  className="review-item-images"
                  onClick={(e) => {
                    reviewImageDataHandler(imgIdx, list);
                  }}
                  style={{
                    width:
                      reviewType === "blog"
                        ? "calc((100% - 26px)/4*1.1)" // 블로그 일때 이미지 사이즈
                        : isComment
                          ? "" // 댓글일때 이미지 사이즈
                          : "calc((100% - 16px)/3*1.1)", // 커뮤니티 리뷰일때 이미지 사이즈
                  }}
                  key={`review-item-images-${imgIdx}`}
                >
                  <img
                    src={getImageUrlWithMaxWidth(image.url, 600)}
                    alt={"review images"}
                    onError={imgErrorHandler}
                    onLoad={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.opacity = "1";
                    }}
                    referrerPolicy="no-referrer"
                    loading="lazy"
                  />
                </li>
              ))}
            </ul>
          )}
          {/* 태그 - 커뮤니티 리뷰에만 있음 댓긅X 블로그 리뷰X */}
          {!isComment &&
            !isBlog &&
            "tags" in list &&
            Array.isArray(list.tags) &&
            list.tags.length > 0 && (
              <>
                {list.images && Array.isArray(list.images) && list.images.length > 0 && (
                  <Blank height={8} />
                )}
                <ul className="review-item-tags-wrap">
                  {list.tags.map((tag: any, idx: number) => (
                    // <li key={`list-${list.uuid}-tag-${tag.id}-${idx}`}>#{tag.name}</li>
                    <Chip
                      size="small"
                      theme="gray100"
                      type="outline"
                      key={`list-${list.uuid}-tag-${tag.id}-${idx}`}
                    >
                      #{tag.name}
                    </Chip>
                  ))}
                </ul>
              </>
            )}
          {/* 답변 - 커뮤니티 리뷰에만 있음 댓긅X 블로그 리뷰X */}
          {viewType === "list-summary" && // 요약보기 일때만 답변 노출
            !isBlog &&
            !isComment &&
            "answer" in list &&
            list.answer !== null && (
              <div className="review-item-answer-wrap">
                <div className="review-item-answer-top">
                  <div className="answer-name">{list.answer.authorNick}</div>
                  <span className="answer-date">
                    {list.answer.regTsp?.substr(0, 10)?.replace(/-/g, ".")}
                  </span>
                </div>
                <p>{list.answer.content}</p>
              </div>
            )}
        </>
      )}
    </div>
  );
};

// 리뷰 아이템
export const ReviewItem = (props: {
  list: ICommunityListItem | ICommunityCommentListItem;
  viewType?: TViewType;
  reviewType?: TReviewType;
}) => {
  // props
  const { list, viewType = "list-summary", reviewType } = props;

  return (
    <>
      {"state" in list && list.state === 0 ? (
        <p className="review-item-deleted">작성자에 의해 삭제된 댓글입니다.</p>
      ) : "state" in list && list.state === 3 ? ( // 신고된 댓글?
        <p className="review-item-deleted">{list.content}</p>
      ) : (
        <>
          <ReviewItemHeader list={list} reviewType={reviewType} />
          <ReviewItemBody list={list} viewType={viewType} reviewType={reviewType} />
          <ReviewItemFooter list={list} reviewType={reviewType} viewType={viewType} />
        </>
      )}
    </>
  );
};

// 블라인드 리뷰 아이템
export const BlindReviewItem = (props: {
  list: ICommunityListItem;
  viewType?: TViewType;
  reviewType?: TReviewType;
}) => {
  // props
  const { list, viewType = "list-summary", reviewType } = props;

  return (
    <>
      <ReviewItemHeader list={list} reviewType={reviewType} />
      <div className="blind-content-wrap">
        <em>사용자 요청에 따라 비공개되었습니다.</em>
        <span>(정보통신망 관렵법에 의거)</span>
      </div>
    </>
  );
};

// 댓글 아이템
export const ReviewCommentItem = (props: {
  list: ICommunityCommentListItem[];
  commentCount: number;
}) => {
  // props
  const { list, commentCount } = props;

  // 댓글 로딩 스피너
  const [showLoader, setShowLoader] = useState<boolean>(true);

  useEffect(() => {
    if (list) {
      setShowLoader(false);
    }
  }, [list]);

  return (
    <>
      {commentCount > 0 && (
        <div className="review-item-comment-wrap">
          <Blank height={8} margin={"0 -20px"} color={"#f7f7f7"} /> {/* gray30 */}
          <div className="review-list-title">
            <h3>댓글</h3>
          </div>
          <div className="review-list-contents" style={{ position: "relative" }}>
            {
              showLoader &&
                Array.from({ length: 2 }).map((_, idx) => (
                  <CommentSkeleton key={`comment-skeleton-${idx}`} />
                )) // 댓글 아이템 2개 더미
            }
            {!showLoader && list && list.length > 0 && (
              <>
                {list.map((comment: ICommunityCommentListItem, cIdx) =>
                  comment.depth === 1 ? (
                    <div
                      className="review-item review-item-comment"
                      key={`review-item-comment-${cIdx}`}
                    >
                      <ReviewItem list={comment} viewType="list-detail" />
                    </div>
                  ) : (
                    <div
                      className="review-item review-item-reply-comment"
                      key={`review-item-replies-${cIdx}`}
                    >
                      <ReviewItem list={comment} viewType="list-detail" />
                    </div>
                  ),
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

const CommentSkeleton = () => {
  return (
    <div className="review-item review-item-comment">
      <div className=" review-item-header review-item-header-comment">
        <div className="user-icon">
          <SkeletonBase width={36} height={36} borderRadius={"50%"} />
        </div>
        <div className="user-info-wrap">
          <Blank height={1} />
          <SkeletonBase width={"6rem"} height={15} />
          <SkeletonBase width={"3rem"} height={13} />
        </div>
        <div className="user-writing-time">
          <SkeletonBase width={"3rem"} height={13} />
        </div>
      </div>
      <div className="review-item-body review-item-body-comment">
        <SkeletonBase width={"70%"} height={15} />
        <Blank height={2} />
        <SkeletonBase width={"70%"} height={15} />
      </div>
      <div className="review-item-footer review-item-footer-comment">
        <div className="footer-action review-like-cnt">
          <SkeletonBase width={"2rem"} height={15} />
        </div>
        <div className="footer-action review-comment-cnt">
          <SkeletonBase width={"3rem"} height={15} />
        </div>
        <div className="footer-action review-more-btn">
          <SkeletonBase width={"2rem"} height={15} />
        </div>
      </div>
    </div>
  );
};
